import { KayttajanTiedot } from '../../model/kayttaja'
import { FirestoreTositteenHistoria } from '../../model/tosite'

export type TositteenTallentaja = Pick<KayttajanTiedot, 'uid' | 'euid'>

export type TositteenHistoriakopio<T> = T & Pick<FirestoreTositteenHistoria, 'tallentaja' | 'tallentaja_euid'>

export const annaTositteenHistoriakopio = <T extends object>(tosite: T, tallentaja: TositteenTallentaja): TositteenHistoriakopio<T> => {
  const historia: TositteenHistoriakopio<T> = { ...tosite, tallentaja: tallentaja.uid }
  if (tallentaja.euid) {
    historia.tallentaja_euid = tallentaja.euid
  }
  return historia
}
